<template>
	<v-card data-tour-scope="additional-tab-form">
		<v-toolbar fixed dark color="primary">
			<v-btn icon dark @click="close">
				<v-icon>mdi-close</v-icon>
			</v-btn>
			<v-toolbar-title>Nuova tab aggiuntiva</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<v-btn dark text data-tour="save" @click.prevent="confirm"> Salva </v-btn>
			</v-toolbar-items>
		</v-toolbar>
		<v-container>
			<AdditionalTabFormBody :item="item" :errors-trans="errorsTrans" :alerts="alerts" :altre="altreTab" :lang="lingueAttive[0] || 'it'" @traduci="traduci" />
		</v-container>
		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
			<span v-html="snackbar.text"></span>
			<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
		</v-snackbar>
	</v-card>
</template>

<script>
import AdditionalTabFormBody from './AdditionalTabFormBody.vue';
import additionalTabForm from './additionalTabForm';

export default {
	name: 'Create',
	components: { AdditionalTabFormBody },
	mixins: [additionalTabForm],
	data() {
		return { id: null };
	},
	async mounted() {
		await this.fetchSettings();
		this.preparaTrans();
		// in fondo all'elenco: posizione dopo l'ultima tab
		const posizioni = this.altreTab.map(t => +t.position || 0);
		this.item.position = posizioni.length ? Math.max(...posizioni) + 1 : 0;
	},
	methods: {
		listaDaSalvare() {
			return [...(this.getSettings.additional_tabs || []), this.item];
		},
	},
};
</script>
